import { Stack } from "@mui/material";
import React from "react";

export const HelenaSectionIcon = ({ icon }: { icon: React.ReactNode }) => {
  return (
    <Stack
      sx={{
        width: "32px",
        height: "32px",
        borderWidth: "3px",
        borderImage: "linear-gradient(135deg, #B9B4FF 0%, #FFFFFF 60.94%)",
        borderRadius: "8px",
        background: "#FFF",
        boxShadow: "0px 2px 4px 0px #6D32F52E",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {icon}
    </Stack>
  );
};
